import type { TodosTableColumn } from "./types";

export const TODOS_TABLE_COLUMNS: TodosTableColumn[] = [
  {
    field: "due_date",
    label: "Due Date",
    tooltip: "The date this form is due by. This date will show to the student",
  },
  { field: "display_name", label: "To-Do Name", tooltip: "" },
  {
    field: "placement",
    label: "Appears In",
    tooltip: "Where should this form appear for the student",
  },
  {
    field: "required",
    label: "Required",
    tooltip: "Checked means the form is required for the student to complete",
    centered: true,
  },
  {
    field: "instruction",
    label: "Instructions",
    tooltip: "Add custom copy to this form",
    centered: true,
  },
  { field: "supporting_url", label: "URL", tooltip: "", centered: true },
  { field: "edit", label: "", tooltip: "" },
];
